module.exports = __webpack_public_path__ + "media/images/v2/header-3-49919e8eb9eb02aad1f4f874a195aa07.png";